import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // 记录错误到控制台，但不阻止应用继续运行
    console.warn('React Error Boundary caught an error:', error, errorInfo);
    
    // 如果是 hydration 错误，尝试恢复
    if (error.message.includes('Hydration') || error.message.includes('hydration')) {
      console.warn('Hydration error detected, attempting recovery...');
      // 短暂延迟后重置错误状态，让 React 重新渲染
      setTimeout(() => {
        this.setState({ hasError: false, error: undefined });
      }, 100);
    }
  }

  render() {
    if (this.state.hasError) {
      // 你可以自定义降级后的 UI 并渲染
      return this.props.fallback || (
        <div className="p-4 bg-red-50 border border-red-200 rounded-md">
          <h3 className="text-red-800 font-medium">Something went wrong</h3>
          <p className="text-red-600 text-sm mt-1">
            The page encountered an error but is attempting to recover automatically.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
} 